<!-- content -->
@switch (storageData.step === ESteps.products) {
  @case (false) {
    @switch (isLoaded) {
      @case (true) {
        <kit-general-setup
          class="block _max-height"
          [content]="typeData"
        [storageData]="storageData"></kit-general-setup>
      }
      @default {
        <div
          class="_loader pos-relative bg-col-4 _max-height w-12"><i
        class="icon-loading inline-flex pos-absolute top-50 left-50"></i></div>
      }
    }
  }
  @case (true) {
    @switch (isFullLoaded) {
      @case (true) {
        <kit-products-setup
          [content]="typeData"
        [storageData]="storageData"></kit-products-setup>
      }
      @case (false) {
        <div
          class="_loader pos-relative bg-col-4 _max-height w-12"><i
        class="icon-loading inline-flex pos-absolute top-50 left-50"></i></div>
      }
    }
  }
}
